import { inject } from '@angular/core';
import { CanMatchFn, Router, UrlSegment } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { WorkspaceService } from '../services/workspace/workspace.service';

export const workspaceExistsGuard: CanMatchFn = (
  route,
  segments: UrlSegment[]
) => {
  const router = inject(Router);
  const workspaceService = inject(WorkspaceService);

  const id = segments[2]?.path; // Acá está el ID

  if (!id) {
    return router.createUrlTree(['/veflo-vault/chat']);
  }

  return workspaceService.getByIdWorkspaces(id).pipe(
    map(() => true), // 200 => pasa
    catchError(() =>
      of(router.createUrlTree(['/veflo-vault/chat']))
    )
  );
};
